import {actionTypes} from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SEND_OTP_FOR_MOBILE_VERIFIED_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.SEND_OTP_FOR_MOBILE_VERIFIED_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.SEND_OTP_FOR_MOBILE_VERIFIED_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.SEND_OTP_FOR_MOBILE_VERIFIED_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.SEND_OTP_FOR_MOBILE_VERIFIED_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
